import React from 'react';
import styled, { css } from 'styled-components';
import { mediaConfined, mediaSmallOnly, mediaSmallOrTiny, mediaConfinedOnly, } from '@xingternal/layout-tokens';
import { FooterLoggedout, LegalFooterStandaloneLoggedout, } from '@xingternal/platform-layout-footer';
import { HeaderLoggedOut } from '@xingternal/platform-layout-header-logged-out';
import { CenterContainer } from '@xingternal/platform-layout-view-wrapper';
import { scale100, spaceL, spaceXXL, xdlColorBackground, } from '@xingternal/tokens';
import { GridContainer } from '@xingternal/xing-grid';
const StyledLoggedOutViewWrapper = styled.div `
  background-color: ${xdlColorBackground};
`;
const StyledFooter = styled.footer `
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: ${spaceXXL} 0;

  @media ${mediaSmallOnly} {
    padding-left: ${spaceL};
  }
`;
const StyledSection = styled.section `
  display: flex;
  flex: 1 1 auto;
  flex-direction: row;
  /* This flex item doesn't seem to grow up to its parent's width without a given initial width */
  width: 0%;

  @media ${mediaSmallOnly} {
    width: 100%;
  }

  @media ${mediaConfined} {
    padding-bottom: 0;
  }

  /* 740px - 1112px */
  @media ${mediaConfinedOnly} {
    justify-content: center;
  }
`;
const StyledMain = styled.main `
  display: flex;
  justify-content: center;

  ${({ $gridless }) => $gridless
    ? css `
          @media ${mediaSmallOrTiny} {
            margin: 0 ${scale100};
            display: initial; // no flex when mobile gridless
          }
        `
    : ''}
`;
const StyledCenterContainer = styled(CenterContainer) `
  @media ${mediaConfined} {
    ${({ type }) => type === 'fullScreen' && `width: 100%;`}
  }
`;
const StyledContent = styled.div `
  display: flex;
  justify-content: center;
  margin: 0 auto;
  width: 100%;

  @media ${mediaConfinedOnly} {
    max-width: 800px;
  }
`;
export const LoggedoutView = ({ children, className, contentClassName, gridClassName, hideLoginButton, hideQuickLinks = false, hideSignupButton, homeLink = '/', loginLink, signupLink, testId, type = 'standard', gridless = false, }) => {
    return (React.createElement(StyledLoggedOutViewWrapper, { className: className, "data-qa": testId && `core-${testId}` },
        React.createElement(HeaderLoggedOut, { hideLoginButton,
            hideSignupButton,
            homeLink,
            loginLink,
            signupLink }),
        React.createElement(StyledCenterContainer, { type: type },
            React.createElement(StyledSection, null,
                React.createElement(StyledContent, { className: contentClassName },
                    React.createElement(StyledMain, { "$gridless": gridless, id: "content" }, gridless ? (children) : (React.createElement(GridContainer, { className: gridClassName, type: type }, children)))))),
        hideQuickLinks ? (React.createElement(StyledFooter, null,
            React.createElement(LegalFooterStandaloneLoggedout, null))) : (React.createElement(FooterLoggedout, { homeLink: homeLink }))));
};
//# sourceMappingURL=loggedout-view.js.map